export const assignationSourceOrganizationsFilter = {
  key: 'alkemics.assignation.source_organizations.id',
  aggregation: {
    value_field: 'alkemics.assignation.source_organizations.name',
  },
  query: 'assignation_source_orgs',
  isAvailable: () => true,
};
